import {put} from 'redux-saga/effects';
import {push} from 'connected-react-router';
import {LOG_OUT} from 'Login/Redux/LoginActions';

export function* logout() {
    // const state = yield select(state => state);
    // const location = getLocation(state);
    // const {pathname, search} = location;
    // debugger;
    // localStorage.setItem('logoutPage', `${pathname}${search}`);

    yield put({
        type: LOG_OUT,
    });

    localStorage.removeItem('jwt');
    push('/login');
}
